import { useHistory, useParams } from 'react-router-dom';

// Componentes
import ModalConfirm from './Components/ModalConfirm';
import SideBarContainer from 'Containers/SideBarContainer';
import Title from './Components/Title';
import { StatusSelect } from './Components/StatusSelect';

// Estilos
import { Info, NameContainer, PageContainer, PermissionsGrid, StyledTextField } from './style';
import { useRolesCreatePage } from './hooks/useRolesCreatePage';
import { PermissionCard } from './Components/PermissionCard';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

export default function RoleCreate() {
  // Obtenemos el ID del rol desde los parámetros de la URL
  const { id = null } = useParams<{ id: string }>();

  // Custom hook para manejar la lógica de creación/edición de roles
  const { register, open, openModal, closeModal, permissions, onChangeChecked, translation, submit, watch, setValue } =
    useRolesCreatePage({
      id,
    });

  // Estado del formulario
  const nombre = watch('name');
  const permisos = watch('permissions');
  const canSubmit = nombre.length > 0 && permisos.length > 0;

  return (
    <SideBarContainer>
      <Title
        title={translation.title}
        subtitle={translation.subtitle}
        cancel={translation.cancel}
        save={translation.save}
        isDisabled={!canSubmit}
        eventButton={openModal}
      />
      <PageContainer>
        <div>
          <p>{translation.name}</p>
          <NameContainer>
            <StyledTextField {...register('name')} placeholder={translation.name} required />
            {permisos.length === 0 ? (
              <Info>
                <TipsAndUpdatesIcon style={{ color: '#00dcf0ff' }} />
                <span>{translation.default_alert}</span>
              </Info>
            ) : (
              <StatusSelect
                active={watch('active')}
                onChange={value => setValue('active', value === 'active')}
                placeholder={translation.status}
                activeText={translation.active}
                inactiveText={translation.inactive}
              />
            )}
          </NameContainer>
        </div>
        <PermissionsGrid>
          {permissions.map(permission => (
            <PermissionCard key={permission.id} permission={permission} onChangeChecked={onChangeChecked} />
          ))}
        </PermissionsGrid>
      </PageContainer>
      <ModalConfirm
        translation={translation}
        open={open}
        onAccept={() => {
          submit();
        }}
        onCancel={() => {
          closeModal();
        }}
      />
    </SideBarContainer>
  );
}
